<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="right tools-view-height mx-1" color="secondary" outlined style="max-width: 40px !important; min-width: 40px !important" @click="handleClick">
                <v-icon class="px-1" small>{{ icon }}</v-icon>
            </v-btn>
        </template>

        <span>{{ $t(label) }}</span>
    </v-tooltip>
</template>
<script>
    export default {
        props: [
            'label',
            'icon'
        ],
        data() {
            return {}
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>